import script from "./GruposAcessoAdministrar.vue?vue&type=script&setup=true&lang=js"
export * from "./GruposAcessoAdministrar.vue?vue&type=script&setup=true&lang=js"

import "./GruposAcessoAdministrar.vue?vue&type=style&index=0&id=7f8fb298&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8fb298"]])

export default __exports__